import React, { useState, useMemo } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import OpinionBarAndLineChart from '@intelligence/v3/components/OpinionBarAndLineChart';

const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType,
    imageType = 'mobile',
    lineData,
    chartSegment,
    dateType,
    baseReleaseTime,
    earliestPeriod,
    dataSource,
    lineXAxisData,
    trendLoading,
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  const { rpdSegementTitleObj } = useMobileOptionList();
  const [chartLoading, setChartLoading] = useState(false);
  const [earliestClickValue, setEarliestClickValue] = useState<any>('');

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    let arr: any = [];
    for (const i in list) {
      arr.push({
        metric: chartSegment,
        source: 'appannie',
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: list[i].value_str,
      });
    }
    if (earliestClickValue != '') {
      for (const n in arr) {
        if (arr[n]) {
          if (arr[n].time == earliestClickValue) {
            arr = arr.slice(n);
          }
        }
      }
    }

    return arr;
  };

  const onChartEarliestClick = (data: any) => {
    setEarliestClickValue(data.value);
  };

  const lineSeriesData = useMemo(() => {
    const dataObj = lineData.find((item: any) => item.metric == chartSegment) || {};
    const arrGameData: any = [];
    const objTemp = {
      cover: dataObj.metric,
      id: dataObj.metric,
      name: rpdSegementTitleObj[dataObj.metric],
      history: getRpdTypeData(dataObj?.history || []),
    };
    arrGameData.push(objTemp);
    return {
      source: Array.isArray(arrGameData) ? arrGameData : [],
    };
  }, [lineData, chartSegment, earliestClickValue]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: 'source',
    topChartsType: 'stats-rpd-line',
    imageType,
    dateType,
    baseReleaseTime: showTimeByDateType(baseReleaseTime, dateType?.toLocaleLowerCase()),
    earliestPeriod: showTimeByDateType(earliestPeriod, dateType?.toLocaleLowerCase()),
    lineSourceIcon: dataSource === 'sensortower' ? 'Sensor Tower' : 'data.ai',
    lineSourceName: dataSource === 'sensortower' ? 'Sensor Tower' : 'data.ai',
    dataSource,
    lineXAxisData,
  });

  return (
    <>
      <div className="card-line">
        {enableOpinionEventAnnotation ? (
          <OpinionBarAndLineChart
            chartLoading={trendLoading || chartLoading}
            lineOption={lineOption}
            chartType={chartType}
            chartHeight={350}
            onChartEarliestClick={onChartEarliestClick}
            enableEventAnnotation
            controlledEventAnnotation={controlledEventAnnotation}
            opinionEventConfig={{
              gameIds: [],
              startTime: '',
              endTime: '',
              dateType,
            }}
          />
        ) : (
          <ChartsIndex
            chartLoading={chartLoading}
            lineOption={lineOption}
            chartType={chartType}
            onChartEarliestClick={onChartEarliestClick}
          />
        )}
      </div>
    </>
  );
};

export default Visualis;
